import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Play, Timer } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";

export default function SavRelancesBar({ onRun }) {
  const { user } = useAuth();
  const [alerts, setAlerts] = useState([]);
  const [delay, setDelay] = useState(null);
  const load = () => {
    api.get("/sav/alerts").then((r) => setAlerts(r.data.items)).catch(() => {});
    api.get("/sav/settings").then((r) => setDelay(r.data.relance_delay_hours)).catch(() => {});
  };
  useEffect(() => { load(); }, []);
  const editDelay = async () => {
    const v = window.prompt("Délai entre deux relances au sous-traitant (en heures, ex. 72) :", String(delay ?? 72));
    if (!v) return;
    try { const { data } = await api.put("/sav/settings", { relance_delay_hours: Number(v.replace(",", ".")) }); setDelay(data.relance_delay_hours); toast.success("Délai enregistré"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Valeur invalide"); }
  };
  const run = async () => {
    try { const { data } = await api.post("/sav/relances/run"); toast.success(`${data.relances_preparees} relance(s) préparée(s), ${data.alertes} alerte(s)`); load(); onRun?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Impossible"); }
  };
  return (
    <div className="space-y-2 mb-3">
      {alerts.map((a) => (
        <Link key={a.id} to={`/sav/${a.sav_id}`} className="flex items-center gap-3 px-4 py-2.5 border-l-4 bg-status-erreurBg border-status-erreurText hover:opacity-90" data-testid={`sav-alert-${a.sav_id}`}>
          <AlertTriangle className="w-4 h-4" /><span className="text-sm font-medium">{a.message} ({a.reference}) — 3 relances sans réponse, choisir un nouveau sous-traitant</span>
        </Link>
      ))}
      <div className="flex items-center gap-3 text-[11px] text-norea-textMuted">
        <span className="inline-flex items-center gap-1"><Timer className="w-3.5 h-3.5" />Relances au sous-traitant après <strong className="text-norea-text" data-testid="sav-delay">{delay ?? "…"} h</strong> sans réponse (vérifié toutes les 15 min)</span>
        {user?.role === "admin" && <>
          <button onClick={editDelay} className="underline hover:text-norea-text" data-testid="sav-delay-edit">Modifier</button>
          <button onClick={run} className="inline-flex items-center gap-1 underline hover:text-norea-text" data-testid="sav-relances-run"><Play className="w-3 h-3" />Vérifier maintenant</button>
        </>}
      </div>
    </div>
  );
}
